import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    IPaymentDayType
} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/IPaymentDayType";


const useApiGetPaymentDayType = (pk: number | undefined): UseQueryResult<IPaymentDayType, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, pk: number | undefined): Promise<IPaymentDayType> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/payment/payment_day_type/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetPaymentDayType", pk],
        queryFn: () => doGet(selectedCompany?.company_token, pk),
        enabled: !!pk
    })
};

export default useApiGetPaymentDayType